import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { handleError } from '@/services/errorHandler.js'
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { getPlans, getSubscriptionOfAccount, getEntitlementsOfAccount } from '@/services/api.js'
import { usePaymentContext } from '@/context-state/PaymentContext.jsx'

export const PaymentDataProvider = ({ children }) => {

    const [isFetched, setIsFetched] = useState(false)
    const { setPlans, setSubscription, updateEntitlements } = usePaymentContext()

    const fetchEssentialPaymentsData = async () => {
        try {

            const [plansResponse, subscriptionResponse, entitlementsResponse] = await Promise.all([
                getPlans(),
                getSubscriptionOfAccount(),
                getEntitlementsOfAccount()
            ])

            // Might need to move to another data provider in the future.
            setSubscription(subscriptionResponse.data)
            setPlans(plansResponse.data)
            updateEntitlements(entitlementsResponse.data)

            setIsFetched(true)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        }
    }


    useEffect(() => {
        if (!isFetched) {
            fetchEssentialPaymentsData()
        }
    }, [])

    // return children

    return (
        isFetched ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
    )
}